import {
    CHANGE_REGION_AREA,
    CHANGE_COORD_AREA
} from './actions';

const initData = {
    region: '0',
    coord: []//coords = [緯度(北), 緯度(南), 経度(西), 経度(東)]
};

export function modelAreaReducer(state = initData, action) {
    switch (action.type) {
        case CHANGE_REGION_AREA:
            return changeRegionReduce(state, action);
        case CHANGE_COORD_AREA:
            return changeCoordReduce(state, action);
        default:
            return state;
    }
}

export function changeRegionReduce(state, action) {
    return {
        ...state,
        region: action.value
    };
}

export function changeCoordReduce(state, action) {
    return {
        ...state,
        coord: action.coord
    };
}